import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const userData = () => ({
    PolicyId: null,
    PhoneNumber: null,
    SpecialistType: null,
    InterventionAddress: null,
    EquipmentType: null,
    Vendor: null,
    Model: null,
    PhotoUrl: null,
    Comments: "",
    ServiceType: null,
    VisitFor: null,
    SaxId: null,
    Symptoms: null,
    OccurranceData: null,
    Source: "web",
    WasDoctor: null,
    ChildBirthDate: null
});

export default new Vuex.Store({
    state: {
        // This data will be sent for claim creation
        userData: userData(),

        // Only used for auth, won't be sent for claim creation
        pesel: null, // TODO move to userData
        userName: null,
        policy: null,

        itemNumber: null,

        loading: false,
        activePage: "",
        steps: [],
        assistanceStep: null,
        verificationResult: null,
        ServiceTypeList: [
            {
                k: 'zakwaterowanie',
                v: 'Zakwaterowanie'
            },
            {
                k: 'transport',
                v: 'Transport mienia'
            },
            {
                k: 'przechowanie',
                v: 'Przechowanie i dozór mienia\n'
            },
            {
                k: 'inne',
                v: 'Inne (wpisz)'
            },
        ],
        EquipmentTypeList: {
            agd: [
                {
                    k: 'pralka',
                    v: 'Pralka'
                },
                {
                    k: 'suszarka',
                    v: 'Suszarka'
                },
                {
                    k: 'odkurzacz',
                    v: 'Odkurzacz'
                },
                {
                    k: 'lodowka',
                    v: 'Lodówka'
                },
                {
                    k: 'piekarnik',
                    v: 'Piekarnik'
                },
                {
                    k: 'plyta',
                    v: 'Płyta'
                },
                {
                    k: 'inne',
                    v: 'Inne (wpisz)'
                },
            ],
            rtv: [
                {
                    k: 'tv',
                    v: 'Telewizor'
                },
                {
                    k: 'hifi',
                    v: 'Sprzęt Hi-FI'
                },
                {
                    k: 'odtwarzacz',
                    v: 'Odtwarzacz CD/DVD'
                },
                {
                    k: 'telefon_kom',
                    v: 'Telefon kom'
                },
                {
                    k: 'inne',
                    v: 'Inne (wpisz)'
                },
            ],
            elektronika: [
                {
                    k: 'laptop',
                    v: 'Laptop'
                },
                {
                    k: 'tablet',
                    v: 'Tablet'
                },
                {
                    k: 'komputer',
                    v: 'Komputer stacjonarny'
                },
                {
                    k: 'inne',
                    v: 'Inne (wpysz)'
                },
            ]
        },
    },
    actions: {
        // Actually, add subscriber question!
        getPesel({ commit, state }) {
            return Vue.axios.post(
                `https://${window.hostname}/insura/addsubscriberquestion`,
                {
                    ClmNumber: state.itemNumber,
                    Question: "Co z moją sprawą?",
                    Name: state.userName.split(' ')[0],
                    Surname: state.userName.split(' ')[1],
                    Telephone: state.userData.PhoneNumber,
                }
            );
        },


        getClaimData({ commit, state }) {
            return Vue.axios.post(
                `https://${window.hostname}/insura/findclaim`,
                { ClmNumber: state.itemNumber }
            );
        },


        findPolicy({ commit, state }, payload) {
            let {searchType, value, saxId} = payload;
            return Vue.axios.get(
                `https://${window.hostname}/insura/findpolicy/${saxId}/${searchType}/${value}`
            );
        },
        createClaim({ commit, state }, url) {
            commit("setLoading", true);
            Vue.axios
                .post(
                    `https://${window.hostname}/insura/${url}`,
                    state.userData
                )
                .then(res => {
                    if (!res.data.ClmNumber) {
                        commit("setLoading", false);
                        commit("setAssistanceStep", "dataSentError");
                        return;
                    }
                    commit("setNumber", res.data.ClmNumber);
                    commit("setLoading", false);

                    commit("setAssistanceStep", "dataSent");
                });
        },
        sendPhoto({ commit, state }, data) {
            return Vue.axios.post(`/api/images`, data);
        }
    },
    mutations: {
        setUserData(state, data) {
            state.userData = {
                ...state.userData,
                ...data
            };
        },
        setActivePage(state, page) {
            state.activePage = page;
        },
        setAssistanceStep(state, step) {
            state.assistanceStep = step;
        },
        setHomePage(state) {
            state.activePage = "";
            state.assistanceStep = "";
            state.steps = [];
            const saxId = state.userData.SaxId;
            const policy = state.userData.PolicyId;
            const phone = state.userData.PhoneNumber;
            state.userData = userData();
            state.userData.PolicyId = policy;
            state.userData.PhoneNumber = phone;
            state.userData.SaxId = saxId;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        // Actually, add step
        setStep(state, data) {
            state.steps.splice(data.index, 1, data.step);
        },
        setVerificationResult(state, result) {
            state.verificationResult = result;
            if (result) {
                const rawActualAddress = [
                    result.AdresKraj,
                    result.AdresMiejscowosc,
                    result.AdresPoczta,
                    result.AdresUlica
                ]
                    .filter(el => el != null)
                    .join(" ");
                const rawCorrespondenceAddress = [
                    result.AdresKodPocztowy,
                    result.AdresKorespondencyjnyKodPocztowy,
                    result.AdresKorespondencyjnyKraj,
                    result.AdresKorespondencyjnyMiejscowosc,
                    result.AdresKorespondencyjnyPoczta,
                    result.AdresKorespondencyjnyUlica
                ]
                    .filter(el => el != null)
                    .join(" ");
                state.userData.InterventionAddress =
                    rawActualAddress || rawCorrespondenceAddress;
                state.userData.PolicyId = result.PolicyId;
                state.userData.SaxId = result.SaxId;
            }
        },

        // Only used for auth, won't be sent for claim creation
        setNumber(state, number) {
            state.itemNumber = number;
        },
        setPesel(state, pesel) {
            state.pesel = pesel;
        },
        setUserName(state, userName) {
            state.userName = userName
        },
        setPolicy(state, policy) {
            state.policy = policy;
        }
    },
    getters: {},
    plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store/index.js